<template>
  <div>
    <div class="sort">
      <ul>
        <li
          v-for="(item, index) of sortList"
          :key="index"
          @click="sort(index)"
          :class="item.active ? 'active' : ''"
        >
          <span>{{ item.name }}</span>
          <i
            v-if="item.type == 1 || item.type == 2"
            :class="item.status ? 'up' : 'down'"
          ></i>
        </li>
      </ul>
    </div>
    <van-popup
      v-model="sortShow"
      position="right"
      :style="{ height: '100%', width: '65%' }"
    >
      <div class="interval">
        <input type="number" placeholder="最小值" ref="min" />
        <span>——</span>
        <input type="number" placeholder="最大值" ref="max" />
      </div>
      <div class="btn">
        <button @click="quit">X</button>
        <button @click="reset">重置</button>
        <button @click="confirm">确定</button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Popup } from 'vant';
const sortList = [
  {
    name: '默认',
    type: 0,
    active: true
  },
  {
    name: '价格',
    type: 1,
    active: false,
    status: 0
  },
  {
    name: '上新',
    type: 2,
    active: false,
    status: 0
  },
  // {
  //   name: '筛选',
  //   type: 3,
  //   active: false
  // }
]
export default {
  components: {
    [Popup.name]: Popup
  },
  data () {
    return {
      sortList,
      sortType: {
        price_order: null,
        sale_order: null,
        price_max: null,
        price_min: null
      },
      sortShow: false
    }
  },
  methods: {
    sort (index) {
      let { sortList, sortType } = this
      if (sortList[index].type === 0) {
        for (let i in sortType) {
          sortType[i] = null
        }
        sortList.map(item => {
          if (item.type === 0) {
            item.active = true
          } else {
            item.active = false
          }
        })
      } else {
        sortList[0].active = false
      }
      if (sortList[index].type === 1) {
        sortType.price_order = sortType.price_order ? 0 : 1
        sortList[index].status = sortType.price_order ? 0 : 1
        sortList[index].active = true
      }
      if (sortList[index].type === 2) {
        sortType.sale_order = sortType.sale_order ? 0 : 1
        sortList[index].status = sortType.sale_order ? 0 : 1
        sortList[index].active = true
      }

      if (sortList[index].type === 3) {
        this.sortShow = true
      }
    },
    confirm () {
      const { $refs, sortType, sortList } = this
      let max = $refs.max.value
      let min = $refs.min.value
      sortType.price_max = max < min ? min : max
      sortType.price_min = min > max ? max : min
      $refs.max.value = max < min ? min : max
      $refs.min.value = min > max ? max : min
      sortList.map(item => {
        if (item.type == 3) {
          item.active = true
        }
      })
      this.sortShow = false
    },
    quit () {
      this.sortShow = false
    },
    reset () {
      const { $refs, sortType } = this
      sortType.price_max = $refs.max.value = 0
      sortType.price_min = $refs.min.value = 0

    }
  },
  watch: {
    sortType: {
      handler (newVal) {
        this.$emit('sortType', newVal)
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.sort {
  border-bottom: 1px solid #ececec;
  padding: 0.2rem 0.3rem;
  ul {
    display: flex;
    li {
      flex: 1;
      font-size: 0.28rem;
      text-align: center;
      line-height: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.active {
  color: #ff6161;
}
.interval {
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.2rem;
  input {
    width: 1.8rem;
    padding: 0.1rem;
    border-radius: 30px;
    background: #f7f7f7;
    border: none;
    &::-webkit-input-placeholder {
      color: rgb(206, 206, 206) !important;
      text-align: center;
    }
  }
}
.btn {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  button {
    font-size: 0.3rem;
    width: 2rem;
    height: 0.8rem;
    background: #fff;
    border: 1px solid rgb(235, 235, 235);
  }
  :nth-child(1) {
    width: 1rem;
  }
  :nth-child(3) {
    background: #ff6161;
    color: #fff;
  }
}

.up,
.down {
  width: 0.3rem;
  height: 0.3rem;
  display: inline-block;
  margin-left: 0.1rem;
}
.up {
  background: url("../../../assets/icon/up.png") no-repeat 50%/100%;
}
.down {
  background: url("../../../assets/icon/down.png") no-repeat 50%/100%;
}
</style>